import Vue from 'vue';

Vue.component('vuetable_station_changeset_pricebook', () =>
    import(/* webpackChunkName: 'station-pricebook-change-set' */ './pricebook-station-change-set.vue'),
);

Vue.component('vuestationchangeset', () =>
    import(/* webpackChunkName: 'station-pricebook-change-set' */ './station-changeset-details.vue'),
);
